const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "EPIRB_GPS_ENABLED_TYPES_RETRIEVED":
            return action.epirbGpsEnableds;

        default:
            return state;
    }
}
